import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Router, NavigationStart, NavigationEnd, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { routing } from './app.routing';
import { AppComponent } from './app.component';
import { PagesModule } from '../app/pages/pages.module';
import { StructureModule } from './structure/structure.module';
import { TopBarComponent } from './components/top-bar/top-bar.component';
import { DashboardsAlphaComponent } from './structure/dashboards/alpha.page';
import { PasswordService } from '../api/password/password.service';
import { MenuLeftComponent } from './components/menu-left/menu-left.component';
import { FooterComponent } from './components/footer/footer.component';
import { ApiConstant } from '../api/api.constant';
import { MasterDataConstant } from '../api/masterdata.constant';
import { LoginService } from '../api/login/login.service';
import { DashboardService } from '../api/dashboard/dashboard.service';
import { FaqService } from '../api/faq/faq.service';
import { KeywordService } from '../api/keyword/keyword.service';
import { CountryService } from '../api/country/country.service';
import { CountryGroupService } from '../api/countrygroup/countrygroup.service';
import { RegisterService } from '../api/register/register.service';
import { FillingStationAreaService } from '../api/fillingstationarea/fillingstationarea.service';
import { FillingStationService } from '../api/fillingstation/fillingstation.service';
import { FillingStationDeletedService } from '../api/fillingstationdeleted/fillingstationdeleted.service';
import { FillingStationIssueService } from '../api/fillingstationissue/fillingstationissue.service';
import { ApplicationService } from '../api/application/application.service';
import { NotificationService } from '../api/notification/notification.service';
import { UserService } from '../api/user/user.service';
import { UserDeletedService } from '../api/userdeleted/userdeleted.service';
import { UserDetailsService } from '../api/userdetails/userdetails.service';
import { UserLogService } from '../api/userlog/userlog.service';
import { PagesLoginAlpha } from '../app/pages/login-alpha.page';
import { HttpManagerService } from '../api/httpmanager.service';
import { BloguserService } from 'api/bloguser/bloguser.service';
import { BlogpostService } from 'api/blogpost/blogpost.service';
import { BlogPostdetailsService } from 'api/blogpostdetails/blogpostdetails.service';
import { BlogtagService } from 'api/blogtag/blogtag.service';
import { BlogcategoryService } from 'api/blogcategory/blogcategory.service';
import { PortfolioService } from 'api/portfolio/portfolio.service';
import { ContactUsService } from 'api/contactus/contactus.service';
import { ReplaceDataService } from 'api/replacedata/replacedata.service';
import { FeedbackService } from 'api/feedback/feedback.service';
import { MobilecrashreportService } from 'api/mobilecrashreport/mobilecrashreport.service';
import { AdmincrashreportService } from 'api/admincrashreport/admincrashreport.service';
import { BackupdbService } from 'api/backupdb/backupdb.service';
import { ChatService } from 'api/chat/chat.service';
declare var NProgress: any;
@NgModule({
  declarations: [
    AppComponent, TopBarComponent, MenuLeftComponent, FooterComponent, DashboardsAlphaComponent, PagesLoginAlpha
  ],
  imports: [
    BrowserModule, FormsModule, HttpModule, RouterModule, PagesModule, NgbModule.forRoot(), StructureModule, routing
  ],
  providers: [ApiConstant, LoginService, HttpManagerService, ReplaceDataService,
    DashboardService, UserLogService,
    PasswordService,
    FaqService, KeywordService, UserService,UserDeletedService, UserDetailsService,
    CountryService, CountryGroupService, NotificationService, FeedbackService,
    RegisterService, ApplicationService, BloguserService, Title,
    BlogpostService,
    BlogPostdetailsService,
    BlogtagService,
    BlogcategoryService,
    PortfolioService,
    ContactUsService,
    FillingStationAreaService,
    FillingStationService,
    FillingStationDeletedService,
    FillingStationIssueService,
    MasterDataConstant,
    MobilecrashreportService, AdmincrashreportService,
    BackupdbService,
    ChatService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private router: Router) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        NProgress.start();
      }
      if (event instanceof NavigationEnd) {
        setTimeout(function () {
          NProgress.done();
        }, 2000);
      }
    });
  }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/app.module.ts